export enum RideRoutePaneType {
    ADD = 'ADD',
    EDIT = 'EDIT',
}